module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', [_c('h1', {
    staticClass: "navTitle"
  }, [_vm._v("Rack, Ruin and Murder")]), _vm._v(" "), _c('h2', {
    staticClass: "navTocTitle"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('ol', {
    attrs: {
      "id": "tocList"
    }
  }, [_c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/cover",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("Cover")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter0",
      "title": "Title Page"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1",
      "title": "Dedication"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter2",
      "title": "Chapter 1"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("Chapter 1")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter3",
      "title": "Chapter 2"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("Chapter 2")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter4",
      "title": "Chapter 3"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("Chapter 3")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("Chapter 4")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("Chapter 5")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("Chapter 6")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("Chapter 7")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("Chapter 8")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("Chapter 9")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("Chapter 10")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("Chapter 11")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("Chapter 12")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("Chapter 13")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("Chapter 14")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("Chapter 15")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("Chapter 16")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("Chapter 17")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("Chapter 18")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("Chapter 19")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("Chapter 20")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("The Campbell and Carter Mysteries")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("Copyright")])])])])]), _vm._v(" "), _c('nav', {
    attrs: {
      "epub:type": "landmarks",
      "hidden": "hidden",
      "id": "landmarks"
    }
  }, [_c('h2', [_vm._v("Guide")]), _vm._v(" "), _c('ol', {
    attrs: {
      "id": "landmarksList"
    }
  }, [_c('li', [_c('span', {
    attrs: {
      "epub:type": "cover",
      "href": "#/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "bodymatter",
      "href": "#/chapter0"
    }
  }, [_vm._v("Start Reading")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "bodymatter",
      "href": "#/chapter1"
    }
  }, [_vm._v("Dedication")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0